
import KeyMirror from "keymirror";

export const ActionTypes = KeyMirror({
  SET_ACTIONS: null,
});

export interface IActionsState {
  actions: Action[];
}